import actionConstants from '../constants/ActionConstants';

const initialState = {
  error: '',
  isfetching: false,
  success: '',
  isSuccess: false,
};

export default function addImageDetails(state = initialState, action) {
  switch (action.type) {
    case actionConstants.ADD_UPLOADED_IMAGE_DETAILS_REQUEST:
      return {
        ...state,
        isfetching: true,
        isSuccess: false
      };
    case actionConstants.ADD_UPLOADED_IMAGE_DETAILS_SUCCESS:
      return {
        ...state,
        isfetching: false,
        success: action.message,
        isSuccess: true,
      };
    case actionConstants.ADD_UPLOADED_IMAGE_DETAILS_FAILURE:
      return {
        ...state,
        error: action.error,
        isfetching: false,
      };
    case actionConstants.CLEAR_STATE:
      return {
        ...state,
        isSuccess: false,
        error: '',
      };
    default:
      return state;
  }
}
